import React from 'react'

import Text from '../../ui/Text'
import { isPartnerDomain, isSupportDomain } from '../../lib/currentDomain'
import { ErrorCodeInstructions } from '../enums/errorCodeEnum'

export const getErrorcodeInstructions = (errorInstruction?: ErrorCodeInstructions) => {
    let instructionTranslationKey = 'errorInstruction' + errorInstruction

    if (
        (isSupportDomain || isPartnerDomain) &&
        (errorInstruction === ErrorCodeInstructions.ContactSupport ||
            errorInstruction === ErrorCodeInstructions.IfProblemRemainsContactSupport)
    )
        instructionTranslationKey = 'errorInstruction' + errorInstruction + 'ForPartnerAndSupport'

    return (
        <div className="flex gap-2 align-items-start">
            <i className="pi pi-check-circle text-green-500"></i>
            <Text code={instructionTranslationKey} />
        </div>
    )
}

export const showErrorMessagesForIgnoreSchedule = (error: string) => {
    if (error === 'NoOngoingSession') return <Text code="NoOngoingSession" />
    if (error === 'NoScheduleForConnector') return <Text code="NoScheduleForConnector" />
    if (error === 'OverridingScheduleExists') return <Text code="OverridingScheduleExists" />
    if (error === 'OtherInvalid') return <Text code="msgIgnoreScheduleFailed" />
}
